// Lista de consultores via API própria (GET /api/consultants — só ativos)
import { useState, useEffect } from 'react';
import { api } from '../lib/api';
import type { Consultant } from '../types/consultant';
import { logger } from '../utils/logger';

// Shape que a API devolve (server: GET /api/consultants)
interface ApiConsultant {
  id: string;
  userId: string;
  displayName: string;
  bio: string;
  photoUrl: string | null;
  specialties: string[];
  rateCredits: number;
  status: string;
  createdAt: string;
}

const fromApi = (c: ApiConsultant): Consultant => ({
  id: c.id,
  name: c.displayName,
  specialty: c.specialties.join(', '),
  imageUrl: c.photoUrl ?? '',
  rating: 0, // reviews não existem mais no MVP
  chatPrice: c.rateCredits,
  emailPrice: c.rateCredits,
  studyPrice: c.rateCredits,
  available: c.status === 'active',
});

export const useConsultants = () => {
  const [consultants, setConsultants] = useState<Consultant[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let mounted = true;

    const loadConsultants = async () => {
      if (!mounted) return;

      setLoading(true);
      try {
        const { consultants: apiConsultants } = await api.get<{ consultants: ApiConsultant[] }>('/consultants');
        if (mounted) setConsultants((apiConsultants ?? []).map(fromApi));
      } catch (err) {
        if (mounted) {
          logger.error('Error loading consultants:', err);
          setError(err instanceof Error ? err : new Error('Erro ao carregar consultores'));
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    loadConsultants();
    return () => { mounted = false; };
  }, []);

  return { consultants, loading, error };
};